import { useState, useEffect } from "react";
import "./Carousel.scss";
import arrow from "../../assets/icons/arrow.svg";

const Carousel = ({ images }) => {
    const [current, setCurrent] = useState(0);

    const prevSlide = () => {
        setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const nextSlide = () => {
        setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 5000);

        return () => clearInterval(interval);
    }, [current]);

    return (
        <div className="Virasat-Carousel">
            <div className="Virasat-Carousel-preview">
                <div className="arrow left" onClick={prevSlide}>
                    <img alt="" src={arrow} />
                </div>
                <img src={images[current].src} alt="" className="Virasat-Carousel-preview-img" />
                <div className="arrow right" onClick={nextSlide}>
                    <img alt="" src={arrow} />
                </div>
            </div>
            <div className="Virasat-Carousel-thumbs">
                {images.map((img, i) => (
                    <img
                        key={i}
                        src={img.src}
                        alt=""
                        className={`Virasat-Carousel-thumbs-img ${i === current ? "active" : ""}`}
                        onClick={() => setCurrent(i)}
                    />
                ))}
            </div>
        </div>
    );
};

export default Carousel;
